import Header from "./components/Header"
import Main from "./pages/Main"
import Directories from "./pages/Directories"
import FilesProvider from "./fmanlibs/FilesProvider"
import SelectionProvider from "./fmanlibs/SelectionProvider"
import Resizer from "./gui/Resizer/Resizer"
import Footer from "./components/Footer"

export default function App(){
    return <SelectionProvider><FilesProvider>
        <Header/>
        <div className="body flex1 flex">
            <Resizer min={64} max={300}><Directories/></Resizer>
            <Main/>
        </div>
        <Footer/>
    </FilesProvider></SelectionProvider>
}